import { Link, useParams } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { Button } from "@/components/ui/button";
import { AssetsTab } from "@/features/worksheets/components/tabs/assets-tab";
import { BankingTab } from "@/features/worksheets/components/tabs/banking-tab";
import { FinancialTab } from "@/features/worksheets/components/tabs/financial-tab";
import { IncexpTab } from "@/features/worksheets/components/tabs/incexp-tab";
import { OfferTab } from "@/features/worksheets/components/tabs/offer-tab";
import { PersonalTab } from "@/features/worksheets/components/tabs/personal-tab";
import { WorksheetTabs } from "@/features/worksheets/components/worksheet-tabs";
import type { WorksheetTab } from "@/features/worksheets/types";
import { useActiveClient } from "@/layouts/client-layout";

/**
 * Financial-worksheet sub-pages for a case. The `:tab` route param selects the
 * active section; the worksheet + its 1-1 income/expense row are created on
 * first access by the backend.
 */
export default function ClientWorksheetsPage() {
  const { client } = useActiveClient();
  const { caseId, tab } = useParams<{ caseId: string; tab: string }>();
  const active = (tab ?? "personal") as WorksheetTab;

  function renderTab() {
    switch (active) {
      case "financial":
        return <FinancialTab caseId={caseId!} />;
      case "assets":
        return <AssetsTab caseId={caseId!} />;
      case "banking":
        return <BankingTab caseId={caseId!} />;
      case "incexp":
        return <IncexpTab caseId={caseId!} />;
      case "offer":
        return <OfferTab caseId={caseId!} />;
      default:
        return <PersonalTab caseId={caseId!} clientId={client.id} client={client} />;
    }
  }

  return (
    <div className="grid gap-6">
      <div className="flex items-center gap-3">
        <Button asChild variant="ghost" size="sm">
          <Link to={`/client/${client.id}/cases/${caseId}`}>
            <FiArrowLeft className="size-4" /> Back to case
          </Link>
        </Button>
        <h2 className="text-xl font-semibold">Financial Worksheet</h2>
      </div>
      <WorksheetTabs clientId={client.id} caseId={caseId!} />
      {renderTab()}
    </div>
  );
}
